export const ExperimentsConsts = {
  WixFormsMigration: 'specs.bookings.WixFormsMigration',
  UseMoment: 'specs.bookings.MyBookingsUseMoment',
  RemoveSkipPreferencesModalParam:
    'specs.bookings.removeSkipPreferencesModalParam',
  BookAgainController: 'specs.bookings.bookAgainController',
  RemoveReschedulePricingPlanCheck:
    'specs.bookings.removeReschedulePricingPlanCheck',
  AllDayMultiDayEvents: 'specs.bookings.AllDayMultiDayEvents',
  SubscriptionPricingUoU: 'specs.bookings.SubscriptionPricingUoU',
  MyBookingsSettingsWds: 'specs.bookings.WdsMyBookingsSettings',
};
